<template>
  <div class="cost-proportions d-flex" :class="{ small: variant === 'small' }">

    <div
      class="labour position-relative d-flex justify-content-center align-items-center"
      :style="`width: ${proportions}%`"
      v-if="hasPrices"
    >
      <span>{{ proportions }}%</span>
      <span class="description position-absolute">robocizna</span>
    </div>
    <div class="labour position-relative d-flex justify-content-center align-items-center equal" v-else>
      <span>?%</span>
      <span class="description position-absolute">robocizna</span>
    </div>

    <div
      class="parts position-relative d-flex justify-content-center align-items-center"
      :style="`width: ${100 - proportions}%`"
      v-if="proportions !== 100 && hasPrices"
    >
      <span>{{ 100 - proportions }}%</span>
      <span class="description position-absolute">części</span>
    </div>
    <div class="labour position-relative d-flex justify-content-center align-items-center equal" v-else-if="!hasPrices">
      <span>?%</span>
      <span class="description position-absolute">części</span>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    variant: String,
    proportions: Number,
    hasPrices: Boolean,
  },
};
</script>
<style scoped>
.cost-proportions {
  margin: 24px 0 57px 0;
  height: 42px;
  background-color: rgba(240, 240, 240, 1);
  padding: 0;
}

.cost-proportions.small {
  margin: 10px 0 32px 0;
  height: 22px;
}

.cost-proportions .labour {
  font-weight: bold;
  margin: 0;
  background-color: rgba(0, 114, 219, 0.3);
}



.cost-proportions .parts {
  font-weight: bold;
}

.cost-proportions .description {
  color: rgba(172, 179, 191, 1);
  font-size: 16px;
  font-weight: normal;
  top: 45px;
}

.cost-proportions .equal {
  background-color: rgba(255, 0, 214, 0.05);
  width: 50%;
}

.cost-proportions.small .description {
  top: 20px;
}
</style>
